import React from 'react';
import { DateSource, FormattedRelative, InjectedIntl, intlShape } from 'react-intl';

function getAbsoluteDateString(date: DateSource, locale: string) {
    const format = {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: false,
        timeZoneName: 'short',
    };
    return Intl.DateTimeFormat(locale, format).format(new Date(date));
}

export interface Props {
    date: DateSource;
}

export interface Context {
    intl: InjectedIntl;
}

export default function RelativeTime({ date }: Props, { intl }: Context) {
    return (
        <span title={getAbsoluteDateString(date, intl.locale)}>
            <FormattedRelative value={date} />
        </span>
    );
}

RelativeTime.contextTypes = {
    intl: intlShape,
};
